import { gatewayEventScheduler } from "../../../../../../gateways/gatewayEventScheduler";

export const sendEventSchedulerPayload = async (payload: any) => {
  try {
    const response = await gatewayEventScheduler.post(`/event/`, payload);
    return response.data.data || response.data;
  } catch (error) {
    console.error("Error al enviar el event scheduler", error);
    throw error;
  }
};
